import React from 'react';
import DashContainer from 'modules/dashboard/_common/DashContainer';
import CustomersPage from 'modules/dashboard/restaurant/customers/CustomersPage';

export default function DashRestaurantCustomers() {
    return (
        <DashContainer title='Clientes'>
            <CustomersPage />
        </DashContainer>
    );
}
